import {
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useState } from "react";
import { profileData } from "../../../../mock-data/role-and-permission/add-employee-list";
import ActionHeader from "../../../../UI/action-header/action-header";
import GlobalCard from "../../../../UI/card/GlobalCard";
import EmployListModal from "./EmployListModal";
import { checkboxList } from "../../../../mock-data/role-and-permission/addPermissionList";
import "./permissiongroup.scss";
const AddPermission = (props: any) => {
  const [viewAudit, setViewAudit] = useState();

  
  // Mock Array for permission  menu list
  const [menulist, setMenuelist] = useState("Home");
  const checkboxMenuArry = [
    "Home",
    "Teams",
    "Time",
    "Attendance",
    "Growth",
    "Files",
    "Tasks",
    "Benefits",
    "Analysis",
    "Settings",
  ];
  // function for group name and discription
  const [groupData, setGroupData] = useState<any>({
    groupTitle: "",
    groupDiscription: "",
    users: [],
  });
  const [allEmployeeList, setAllEmployeeList] = useState<any>([]);
  const [selectedEmployeeList, setSelectedEmployeeList] = useState<any>([]);
  const [openModal, setOpenModal] = useState(false);

  const groupName = (evnt: any) => {
    setGroupData({ ...groupData, [evnt.target.name]: evnt.target.value });
    // console.log(evnt.target.value);
  };
  const handleSelectEmployee = (employeeType: any) => {
    console.log(employeeType);
    if (employeeType.target.value === "allEmployees") {
      setAllEmployeeList(profileData);
      setGroupData({ ...groupData, users: profileData });
    } else {
      setOpenModal(true);
      setAllEmployeeList(selectedEmployeeList);
    }
  };
  const getFinalUsers = (users: any) => {
    setSelectedEmployeeList(users);
    setGroupData({ ...groupData, users });
  };
  console.log(groupData, "selectedEmployeeList");
  // const changeValue = (e:any)=>{
  //   console.log(e.target.checked);

  // }

  // checkox title function
  const handleGroupTitle = (e: any) => {
    console.log(e.target.checked);
  };

  //save data to array of role & permission
  const handleSaveData = () => {
    props.setCardsData([
      ...props.cardsData,
      {
        title: groupData.groupTitle,
        description: groupData.groupDiscription,
        numberOfEmploye: groupData.users.length,
      },
    ]);
    props.close();
  };
  return (
    <div className="mian_Permission_card_">
      <ActionHeader heading="Add Permission Group" className="custom_style" />
      <GlobalCard>
        <Grid container rowSpacing={3} columnSpacing={3}>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <div className="nameing_permission">
              <h4 className="h4">Name Permission Group</h4>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={8} lg={9}>
            <div className="nameing_permission_input_wraper">
              <label htmlFor="CreateGroup fw-500 ">
                Group Name <span>*</span>
              </label>
              <input
                onChange={groupName}
                type="text"
                name="groupTitle"
                value={groupData.groupTitle}
                placeholder="Create group name"
                className="input br-5"
                required
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <div className="nameing_permission">
              <h4 className="h4">Discription for Permission Group</h4>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={8} lg={9}>
            <div className="nameing_permission_input_wraper">
              <label htmlFor="CreateGroup fw-500 ">
                Group Discription <span>*</span>
              </label>
              <textarea
                value={groupData.groupDiscription}
                name="groupDiscription"
                className="input br-5"
                onChange={groupName}
                required
              />
            </div>
          </Grid>
        </Grid>

        <Divider className="divider" />
        <Grid container rowSpacing={3} columnSpacing={3}>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <div className="nameing_permission">
              <h4 className="h4">Select Who’s In This Group</h4>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={8} lg={9}>
            <div className="permission_select_radio_wraper">
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="RadioButtons"
                  name="employee"
                  onChange={(e) => handleSelectEmployee(e)}
                >
                  <FormControlLabel
                    value="allEmployees"
                    sx={{
                      marginRight: {
                        xs: "20px",
                        sm: "30",
                        md: "40px",
                        lg: "70px",
                      },
                    }}
                    control={
                      <Radio
                        disableRipple
                        sx={{
                          color: "red",
                          "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                            {
                              color: "#4C0027",
                            },
                          "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                            color: "#FFFFFF",
                            backgroundColor: "#4C0027",
                            borderRadius: "50%",
                          },
                        }}
                      />
                    }
                    label="All employees"
                  />
                  <FormControlLabel
                    value="Select employees"
                    control={
                      <Radio
                        // onChange={groupName}

                        disableRipple
                        sx={{
                          "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                            {
                              color: "#4C0027",
                            },
                          "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                            color: "#FFFFFF",
                            backgroundColor: "#4C0027",
                            borderRadius: "50%",
                          },
                        }}
                      />
                    }
                    label="Select employees"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </Grid>
        </Grid>
      </GlobalCard>
      <ActionHeader
        heading="Manage Permissions"
        isbuttonRequired={true}
        buttonName="View Audit"
        handleClick={setViewAudit}
      />
      <div className="manage_permission_main_checboxes">
        <Grid container rowSpacing={3} columnSpacing={3}>
          <Grid item xs={12} sm={2}>
            <GlobalCard classNames="menuCardStyle">
              <List
                sx={{
                  width: "100%",
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                {checkboxMenuArry.map((listItem: any, index) => (
                  <ListItemButton
                    key={index}
                    sx={{
                      padding: "12px 30px",
                      borderLeft:
                        menulist === listItem
                          ? "4px solid #4C0027"
                          : "4px solid #fff",
                      borderRight: "4px solid #fff",
                    }}
                    onClick={() => setMenuelist(listItem)}
                    href={`http://localhost:3000/settings/role-&-permissions#${listItem}`}
                  >
                    <ListItemText
                      primary={listItem}
                      sx={{
                        color: "#4E4B66",
                      }}
                    />
                  </ListItemButton>
                ))}
              </List>
            </GlobalCard>
          </Grid>
          <Grid item xs={12} sm={10}>
            {checkboxList.map(
              ({ title, id, checkboxGroupListMain }, index: number) => (
                <GlobalCard key={id} classNames="Changed_Style" id={id}>
                  <div className="checkbox_outer">
                    <h4 className="h4">{title}</h4>
                    <>
                      {checkboxGroupListMain.map(
                        ({ groupTitle, checkBoxGroupList }) => (
                          <div key={groupTitle}>
                            <div className="checklist_name d-flex align-center ">
                              <input
                                type="checkbox"
                                className="input-checkbox"
                                id={`checkbox${index + 1}`}
                                value={groupTitle}
                                onChange={(e) => handleGroupTitle(e)}
                              />
                              <label htmlFor="chcklist">{groupTitle}</label>
                            </div>
                            {checkBoxGroupList.map(({ name, label, value }) => (
                              <div
                                key={name}
                                className="checklist_childs d-flex align-center"
                              >
                                <input
                                  type="checkbox"
                                  className="input-checkbox"
                                  id={name}
                                  value={value}
                                />
                                <label htmlFor={name}>{label}</label>
                              </div>
                            ))}
                          </div>
                        )
                      )}
                    </>
                  </div>
                </GlobalCard>
              )
            )}
            <div className="Btn_wrapers d-flex align-center">
              <button className="btn btn-disabled" onClick={props.close}>
                Cancel
              </button>
              <button className="btn btn-secondary" onClick={handleSaveData}>
                Save
              </button>
            </div>
          </Grid>
        </Grid>
      </div>
      <EmployListModal
        open={openModal}
        close={() => setOpenModal(false)}
        getFinalUsers={getFinalUsers}
      />
    </div>
  );
};
export default AddPermission;
